/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener('rebuy.add', function(event){
    console.log('rebuy.add event', event.detail);
    event.detail.widget.id == "103219" ? 
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
    })) : ""
});

document.addEventListener('rebuy.remove', function(event){
    console.log('rebuy.remove event', event.detail);
    event.detail.widget.id == "103219" ? 
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
    })) : ""
});

document.addEventListener('variant:changed', function(event) {
  console.log("hihihihihihihi")
   var variant = event.detail.variant; // Gives you access to the whole variant details
    const radios = document.querySelectorAll('.block-swatch__radio');
    const selectedRadio = Array.from(radios).find(radio => radio.checked);
    console.log(variant.available);
    if (!variant.available) {
      const addToCartButtonElement = document.querySelector('.back_in_store.klaviyo-bis-trigger');
      console.log(addToCartButtonElement);
      addToCartButtonElement.style.display = 'block';
      addToCartButtonElement.classList.add("back_in_store");
      addToCartButtonElement.classList.add("klaviyo-bis-trigger");
      addToCartButtonElement.classList.remove("button--disabled");
      addToCartButtonElement.setAttribute("disabled", "disabled");
      addToCartButtonElement.innerHTML = "Notify me when available";
    }

    // https://pthree.atlassian.net/browse/P3MQA-14112
    // else if (!selectedRadio) {
    //     const addToCartButtonElement = document.querySelector('.back_in_store.klaviyo-bis-trigger');
    //     if (addToCartButtonElement) {
    //       addToCartButtonElement.classList.remove("back_in_store");
    //       addToCartButtonElement.classList.remove("klaviyo-bis-trigger");
    //       addToCartButtonElement.classList.add("button--disabled");
    //       addToCartButtonElement.innerHTML = "Select size";
    //     }
    // } else if (!variant.available && selectedRadio) { 
    //   const addToCartButtonElement = document.querySelector('.product-form__payment-container .button.button--primary');
    //   addToCartButtonElement.classList.add("back_in_store");
    //   addToCartButtonElement.classList.add("klaviyo-bis-trigger");
    //   addToCartButtonElement.classList.remove("button--disabled");
    //   addToCartButtonElement.setAttribute("disabled", "disabled");
    //   addToCartButtonElement.innerHTML = "Notify me when available";
    // }

});

const isCartEnabled = window.shopifySettings?.tieredProgressBar === "on"; 

function addProgressBar() {
    if (!isCartEnabled) return;
  
    const cartElement = document.querySelector('.rebuy-cart__flyout-header');
    if (!cartElement) return;
  
    const existingProgressBar = document.querySelector('#progress-bar-container');
    if (existingProgressBar) return;
  
    const progressBarHTML = `
      <div id="progress-bar-container" style="padding: 10px; background: #f9f9f9; position: relative;">
        <div id="tier-labels" style="position: relative; margin-bottom: 5px; height: 20px;">
          <span class="tier-label" data-tier="75" style="position: absolute; transform: translateX(-50%); font-size: 12px;">$75</span>
          <span class="tier-label" data-tier="125" style="position: absolute; transform: translateX(-50%); font-size: 12px;">$125</span>
          <span class="tier-label" data-tier="200" style="position: absolute; transform: translateX(-50%); font-size: 12px;">$200</span>
        </div>
        <div id="progress-bar" style="background: #e0e0e0; border-radius: 8px; height: 10px; width: 100%; position: relative;">
          <div id="progress-bar-fill" style="background: #ABE60B; height: 100%; width: 0%; border-radius: 8px;"></div>
        </div>
        <div id="progress-bar-label" style="margin-top: 5px; text-align: center; font-size: 14px;">
          Add $XX more to unlock next offer!
        </div>
      </div>
    `;
  
    cartElement.insertAdjacentHTML('afterend', progressBarHTML);
  
    updateTierLabels();
  
    updateProgressBar();
  }
  
  function updateTierLabels() {
    const tiers = [75, 125, 200]; 
    const maxTier = 200; 
  
    tiers.forEach((tier) => {
      const label = document.querySelector(`.tier-label[data-tier="${tier}"]`);
      if (label) {
        const leftPosition = (tier / maxTier) * 100;
        console.log(leftPosition)
        label.style.left = `${Math.max(leftPosition === 100 ? 95 : leftPosition)}%`;
      }
    });
  }
  
  function updateProgressBar() {
    if (!isCartEnabled) return; 
  
    const cartSubtotalElement = document.querySelector('.rebuy-cart__flyout-subtotal-amount');
    if (!cartSubtotalElement) return;
  
    const tier1 = 75; 
    const tier2 = 125; 
    const tier3 = 200;
  
    const validSubtotal = Rebuy.Cart.cart.items
      .filter(item => !(item.tags || []).includes('IMAP'))
      .reduce((sum, item) => sum + item.original_price * item.quantity, 0) / 100;
  
    let progressPercentage = Math.min((validSubtotal / tier3) * 100, 100);
  
    const progressBarFill = document.getElementById('progress-bar-fill');
    const progressBarLabel = document.getElementById('progress-bar-label');
  
    progressBarFill.style.width = `${progressPercentage}%`;
  
    if (validSubtotal < tier1) {
      const remaining = (tier1 - validSubtotal).toFixed(2);
      progressBarLabel.textContent = `Add $${remaining} more to unlock 15% discount and free shipping!`;
    } else if (validSubtotal < tier2) {
      const remaining = (tier2 - validSubtotal).toFixed(2);
      progressBarLabel.textContent = `Add $${remaining} more to unlock 20% discount!`;
    } else if (validSubtotal < tier3) {
      const remaining = (tier3 - validSubtotal).toFixed(2);
      progressBarLabel.textContent = `Add $${remaining} more to unlock 25% discount!`;
    } else {
      progressBarLabel.textContent = "You’ve unlocked the maximum discount!";
    }
  }

  function adjustFlickityHeight() {
    if(index < 3){
      const flickityViewports = document.querySelectorAll('.product-list .flickity-viewport');
      if (flickityViewports) {
          flickityViewports.forEach((viewport) => {
            const currentHeight = viewport.scrollHeight + 5;
            viewport.style.height = currentHeight + 'px'; 
          });
      }
      index = index + 1;
    }
  }
  var index = 0;
  
  const observer = new MutationObserver((mutationsList) => {
    mutationsList.forEach((mutation) => {
      if (mutation.addedNodes) {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1 && node.classList.contains('rebuy-cart')) {
            addProgressBar();
          }
        });
      }
    });
    adjustFlickityHeight();
  });
  
  observer.observe(document.body, { childList: true, subtree: true });
  
  document.addEventListener('rebuy:cart.change', () => {
    updateProgressBar();
    updateTierLabels();
  });
  